module.exports = __webpack_public_path__ + "static/solution-picture-6d9c0b1b71db4503ab1fc15e06c53ead.png";